export default __webpack_public_path__ + "static/media/nightRainSeven.fae1713a.jpg";